export default __webpack_public_path__ + "static/media/hyperflash.86ad85ed.png";